import { customAxios } from './customAxios'
export function addAdeguataVerifica(formValues) {
  const config = {
    headers: {
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }
  const data = {
    ...formValues,
    idNodoPratica: '',
    statoRichiesta: '',
    relazione: formValues.motivazioniAdeguataVerifica.join(','),
  }

  const adeguataVerificaRequest = customAxios.post(
    process.env.REACT_APP_BACKEND_HOST +
      '/' +
      process.env.REACT_APP_PATH_NEW_PREFIX +
      '/addAdeguataVerifica',
    data,
    config,
  )
  return adeguataVerificaRequest
}
